export default __webpack_public_path__ + "static/img1-a5baea0305a7017014ee8555764c9f98.jpeg";